import { sectionConfig as config } from "~/config/_pages/home/hero";
import HeroUI from "~/components/ui/hero";
import banner from "~/assets/plans-banners/api-service.svg";

export default function HeroSection() {
  return (
    <HeroUI>
      <HeroUI.Container>
        <HeroUI.Body>
          <HeroUI.Heading title={config.title} suptitle={config.suptitle} />
          <HeroUI.Paragraph>{config.caption}</HeroUI.Paragraph>
          <div className="flex gap-3">
            <HeroUI.Purchase
              label={config.start_button.label}
              link={config.start_button.link}
              buttonVariant="purple"
            />
            <HeroUI.Purchase
              label={config.secondary_button.label}
              link={config.secondary_button.link}
              buttonVariant="sky"
            />
          </div>
        </HeroUI.Body>
        <HeroUI.Banner
          size="lg"
          glow="sky"
          url={banner.src}
          alt={config.title}
        />
      </HeroUI.Container>
      <HeroUI.Glow glowColor="sky" />
    </HeroUI>
  );
}
